import { render } from "./BlocklyComponent.vue?vue&type=template&id=55760b80&scoped=true"
import script from "./BlocklyComponent.vue?vue&type=script&lang=js"
export * from "./BlocklyComponent.vue?vue&type=script&lang=js"

import "./BlocklyComponent.vue?vue&type=style&index=0&id=55760b80&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-55760b80"

export default script